import useStashwiseStore from "@/hooks/useStashwiseStore";
import Image from "next/image";
import Link from "next/link";

export const Popup = () => {
  const { setOpenModal } = useStashwiseStore();
  return (
    <div className="md:w-[400px] w-screen">
      <div className="bg-primary rounded-t-[20px] flex justify-between items-start md:p-6 p-4 md:gap-24 gap-16">
        <h3 className="font-bold text-white text-lg">
          Get a Better Experience on our Mobile App
        </h3>
        <Image
          onClick={() => setOpenModal("downloadMobile", false)}
          src="closemodal.svg"
          alt="close-icon"
          width={20}
          height={20}
          color="white"
          className="cursor-pointer"
        />
      </div>
      <div className="text-secondary md:space-y-4 space-y-3 md:p-6 p-4">
        <p>
          While you can still use Monietab on your browser, the mobile app gives
          you a smoother and more complete experience. It&apos;s faster and
          easier to navigate. You&apos;ll get access to more features.
        </p>

        <p>
          We designed the app specifically for users who want to build good
          money habits with as little friction as possible. That&apos;s hard to
          achieve fully through a web browser.
        </p>

        <DownloadBtns />
      </div>
    </div>
  );
};

//resusable download button component
export function DownloadBtns() {
  return (
    <div className="flex items-center gap-4">
      <Link
        target="_blank"
        href="https://play.google.com/store/apps/details?id=com.stashwise.africa"
        className="bg-primary text-white flex items-center justify-center gap-3 lg:px-6 py-2 rounded-[5px] hover:bg-opacity-80 transition-all duration-300 font-bold lg:w-fit w-1/2"
      >
        <Image src="/google.svg" alt="google" width={20} height={20} />
        <div className="flex flex-col">
          <span className="text-[12px] font-light">GET IT ON</span>
          <span className="text-sm font-bold">Google Play</span>
        </div>
      </Link>

      <Link
        target="_blank"
        href="https://apps.apple.com/app/monietab/id6745721787"
        className="bg-primary text-white flex items-center justify-center gap-3 lg:px-6 py-2 rounded-[5px] hover:bg-opacity-80 transition-all duration-300 font-bold lg:w-fit w-1/2"
      >
        <Image src="/apple.svg" alt="apple" width={20} height={20} />
        <div className="flex flex-col">
          <span className="text-[12px] font-light">Download on the</span>
          <span className="text-sm font-bold">App Store</span>
        </div>
      </Link>
    </div>
  );
}
